import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box, Typography, Paper, Container } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { Error403 } from '../errors';

interface ProtectedAdminRouteProps {
  children?: React.ReactNode;
}

export const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Check if user is logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has admin role
  if (!user.isAdmin) {
    return <Error403 />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedAdminRoute;
